import React from 'react';
import { useTranslation } from 'react-i18next';

export function InfoColumnStaticAttribute({ label, value, cssClass, id }) {
  const { t } = useTranslation();
  return value ? (
    <div id={`item-${id}-block`} className={cssClass}>
      <div id={`item-${id}-label`} className="label">
        {t(label)}
      </div>
      <div id={`item-${id}-value`} className="data">
        {value}
      </div>
    </div>
  ) : null;
}

export default InfoColumnStaticAttribute;
